
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Container } from "../../components/util/container";
import { Section } from "../../components/util/section";
import Posts from "../../components/blog/BlogPosts";
import Header from "../../components/blog/Header";
import { client } from "../../../tina/__generated__/client";
import Link from "next/link";
const GUIDE_TOPICS = [
    { label: "Openings", slug: "openings" },
    { label: "Tactics", slug: "tactics" },
    { label: "Strategy", slug: "strategy" },
    { label: "Endgames", slug: "endgames" },
    { label: "Beginners", slug: "beginners" },
    { label: "Famous Games", slug: "famous-games" },
];
export default function Guides(props: any) {
    return (<Section className="flex-1">
      <Header>
        <h2 className="relative w-full text-3xl font-extrabold tracking-normal text-center text-gray-100 md:text-5xl title-font">
          Improve Your Chess
        </h2>
        <div className="max-w-2xl mx-auto mt-4 text-sm font-normal text-center text-gray-300 md:text-base">
          Guides on openings, tactics, strategy, and more.
        </div>
      </Header>
      <Container size="medium" width="small">
        <section className="pt-10">
          <h3 className="text-lg font-semibold tracking-tight text-slate-900 md:text-xl">
            Explore topics
          </h3>
          <div className="grid grid-cols-1 gap-3 mt-4 sm:grid-cols-2 md:grid-cols-3">
            {GUIDE_TOPICS.map((topic) => (<Link key={topic.slug} href={`/guides/${topic.slug}`} locale={false} className="rounded-xl border border-slate-200 bg-white px-4 py-4 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:border-slate-300 hover:text-slate-900">
                {topic.label}
              </Link>))}
          </div>
        </section>

        <section className="pt-10 pb-12">
          <h3 className="text-lg font-semibold tracking-tight text-slate-900 md:text-xl">
            Latest guides
          </h3>
          <div className="mt-5">
            <Posts data={props.posts} mode="guides"/>
          </div>
        </section>
      </Container>
    </Section>);
}
const getStaticProps = async () => {
    const postsResponse = await client.queries.postConnection({
        filter: { locale: { eq: "en" } },
    });
    const posts = postsResponse.data.postConnection.edges.filter((edge) => {
        const post = edge?.node;
        const categorySlug = post?.category?.slug;
        const folderCategory = post?._sys?.breadcrumbs?.[0];
        return categorySlug !== "news" && folderCategory !== "news";
    });
    return {
        props: {
            posts,
        },
    };
};

    async function __Next_Translate__getStaticProps__1a042aa3d5f__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/guides/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a042aa3d5f__ as getStaticProps }
  